import { takeLatest, put, call, select } from "redux-saga/effects";
import userManager from "user-manager";
import {
  redirectToLoginFailed,
  redirectToLogoutFailed,
  referrerRedirectFailed
} from "actions/authActions";
import { logoutUser } from "./Api";
import fetchSaga from "./fetchSaga";
import actionTypes from "actions/actionTypes";
import { selectUserToken } from "selector/authSelectors";
import { history } from "../store";

function* redirectToLoginSaga({ payload }) {
  try {
    sessionStorage.setItem("auth.referrer", JSON.stringify(payload));

    yield call(userManager.signinRedirect.bind(userManager));
  } catch (err) {
    yield put(redirectToLoginFailed(err));
  }
}

function* loginSuccessSaga() {
  try {
    const referrer = JSON.parse(sessionStorage.getItem("auth.referrer"));

    yield call([history, "push"], referrer);
  } catch (err) {
    yield put(referrerRedirectFailed(err));
  }
}

function* redirectToLogoutSaga() {
  try {
    yield call(fetchSaga, logoutUser, null, true);
    const token = yield select(selectUserToken);
    yield call(userManager.removeUser.bind(userManager));
    yield call(userManager.signoutRedirect.bind(userManager), {
      id_token_hint: token
    });
  } catch (err) {
    yield put(redirectToLogoutFailed(err));
  }
}

export const authSagas = [
  takeLatest(actionTypes.REDIRECT_LOGIN, redirectToLoginSaga),
  takeLatest(actionTypes.REDIRECT_LOGOUT, redirectToLogoutSaga),
  takeLatest(actionTypes.LOGIN_SUCCESS, loginSuccessSaga)
];
